import { Tag } from 'antd'
import { getPlanStatus, Subscription } from '../../models/Billing'
import i18n from '../../i18n/setupLocalization'
import LocalizationKeys from '../../i18n/LocalizationKeys'

interface Props {
  subscription?: Subscription
}

export const StatusTag = ({ subscription }: Props) => {
  if (!subscription)
    return (
      <Tag color="orange">
        {i18n.t(
          LocalizationKeys.Component.Subscription.StatusTag.PaymentRequired
        )}
      </Tag>
    )

  const statusObject = getPlanStatus(subscription)

  if (!statusObject) return <></>

  return (
    <Tag color={statusObject.color}>
      {statusObject.status === 'trial'
        ? i18n.t(statusObject.localizationKey, {
            dayRemaining: statusObject.daysRemaining,
          })
        : i18n.t(statusObject.localizationKey)}
    </Tag>
  )
}

export type StatusTagType = { StatusTag: typeof StatusTag }
